import { createFileRoute } from '@tanstack/react-router';
import { requireSession } from '../lib/authGuard';
import { NoAccess } from '@/app/entry/NoAccess';
import { redirectFromNoAccess } from '@/app/entry/portalGuards';

// Destino de quien no tiene ningún portal; quien sí tiene sale hacia ellos. Sin shell.
export const Route = createFileRoute('/no-access')({
    beforeLoad: async ({ context, location }) => {
        await requireSession(context.auth, location.pathname);
        await redirectFromNoAccess(context.auth);
    },
    component: NoAccess,
});
